<template>
    <div class="projectBox">
        <div class="header">
            <div class="user">{{auctionAccount}}，欢迎您!</div>
            <img
                src="@/image/goback.png"
                alt=""
                style="width: 23px; height: 23px;cursor: pointer;"
                @click="$router.go(-1)"
            />
        </div>
        <titleBar title="拍卖信息" class="mt20"></titleBar>
        <el-descriptions title="" class="ml20r">
            <el-descriptions-item label="拍卖项目名称">{{form.auctionProjectName}}</el-descriptions-item>
            <!-- <el-descriptions-item label="是否需要审核">{{form.examine==1?'是':'否'}}</el-descriptions-item> -->
            <el-descriptions-item label="项目编号">{{form.auctionProjectCode}}</el-descriptions-item>
            <el-descriptions-item label="竞拍起止时间">{{form.auctionStartTime}}--{{form.auctionEndTime}}</el-descriptions-item>
            <el-descriptions-item label="延时周期">{{form.delayPeriod}}分钟/次</el-descriptions-item>
            <!--  &&formLabelAlign.marginConfirmationUserName -->
            <el-descriptions-item label="是否缴纳保证金">{{form.bondIs==1?'是':'否'}}</el-descriptions-item>
            <el-descriptions-item label="保证金" v-if="form.bondIs==1">{{form.bond || 0.00}}元</el-descriptions-item>
            
            
            <el-descriptions-item label="限价类型">{{form.fixedPriceType==0?'最高限价':'最低限价'}}</el-descriptions-item>
            <el-descriptions-item label="起拍价">{{form.startingPrice || 0.00}}元</el-descriptions-item>
            <el-descriptions-item label="加价幅度">{{form.priceIncrease || 0.00}}元</el-descriptions-item>
        </el-descriptions>

        <titleBar title="标的物信息" class="mt20"></titleBar>
        <el-descriptions class="ml20r">
            <!-- <el-descriptions-item label="物资结算单位"></el-descriptions-item> -->
            <el-descriptions-item label="结算数量">{{form.settlementNum}}{{form.companyName}}</el-descriptions-item>
        </el-descriptions>
        <div class="details-box">
            <p class="subject-matter">标的物明细：</p>
            <div style="width:700px">
                <el-table 
                :header-cell-style="{ fontWeight: 400,background:'#F0F5FC',color:'#333333'}"
                :data="tableData" style="margin-bottom:40px">
                    <el-table-column label="序号" prop="" type="index" width="100px"></el-table-column>
                    <el-table-column label="标的物名称" prop="auctionMarkName" width=""></el-table-column>
                    <el-table-column label="数量" prop="auctionMarkNum" width="">
                        <template v-slot="scope">
                            <span>{{scope.row.auctionMarkNum}}{{scope.row.companyName}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-descriptions title="" style="margin-left:50px">
            <el-descriptions-item label="备注">{{form.remarks}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1" class="ml20r">
            <el-descriptions-item label="拍品图片">
                <div class="img-show" v-if="imagesBox.length > 0">
                    <div v-for="(item, index) in imagesBox" :key="index">
                    <div style="position: relative">
                        <img
                        :src="item.filePathUrl"
                        class="img-box"
                        />
                    </div>
                    </div>
                </div>
            </el-descriptions-item>
            <el-descriptions-item label="标的物介绍" class="ml20r">
                <!-- <UeditorBox v-model="form.markIntroduce" ref="markIntroduce" style="width:60%"> </UeditorBox> -->
                <span v-html="form.auctionContent.markIntroduce"></span>
            </el-descriptions-item>
        </el-descriptions>
        <titleBar title="其他信息" class="mt20"></titleBar>
        <el-descriptions :column="1" class="ml20r">
            <el-descriptions-item label="竞拍公告" >
                <!-- <UeditorBox v-model="form.auctionAnnouncement" ref="auctionAnnouncement" style="width:60%"> </UeditorBox> -->
                <span v-html="form.auctionContent.auctionAnnouncement"></span>
            </el-descriptions-item>
            <el-descriptions-item label="竞拍须知">{{form.biddingNotice}}</el-descriptions-item>
            <el-descriptions-item label="保证金须知">{{form.bondNotice}}</el-descriptions-item>
        </el-descriptions>
        <titleBar title="物资对接信息" class="mt20"></titleBar>
        <el-descriptions :column="3" class="ml20r">
            <el-descriptions-item label="提货地址">{{form.deliveryAddress}}</el-descriptions-item>
            <el-descriptions-item label="对接人">{{form.contactPerson}}</el-descriptions-item>
            <el-descriptions-item label="联系方式">{{form.contactInformation}}</el-descriptions-item>
        </el-descriptions>
        <titleBar title="收款账户信息" class="mt20"></titleBar>
        <el-descriptions :column="3" class="ml20r">
            <el-descriptions-item label="收款单位名称">{{form.unitName}}</el-descriptions-item>
            <el-descriptions-item label="开户行">{{form.bankOfDeposit}}</el-descriptions-item>
            <el-descriptions-item label="收款银行账号">{{form.account}}</el-descriptions-item>
        </el-descriptions>
        
        <div>
            <titleBar title="报名信息" class="mt20"></titleBar>
            <el-descriptions :column="3" class="ml20r">
                <el-descriptions-item label="买家性质">{{formLabelAlign.type == 1?'自然人':'企业'}}</el-descriptions-item>
                <el-descriptions-item label="买家名称">{{formLabelAlign.userName}}</el-descriptions-item>
                <el-descriptions-item :label="formLabelAlign.type == 1?'身份证号码':'社会信用代码'">{{formLabelAlign.idCard}}</el-descriptions-item>
                <el-descriptions-item label="联系人">{{formLabelAlign.linkUserName}}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{formLabelAlign.linkUserPhone}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="ml20r">
                <el-descriptions-item :label="formLabelAlign.type == 1?'身份证正反面':'营业执照'">
                    <div class="img-show" v-if="imagesBox2.length > 0">
                        <div v-for="(item, index) in imagesBox2" :key="index">
                        <div style="position: relative">
                            <img
                            :src="item.filePathUrl"
                            class="img-box"
                            />
                        </div>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <!--  -->
            <div v-if="aptitudeUrl.length>0" style="margin-bottom:20px">
                <titleBar title="资质信息" class="mt20"></titleBar>
                <div v-for="(item,index) in aptitudeUrl" :key="index" class="ml20r">
                    <div class="flex-form" @click="uploadClick(item)">
                        <div class="mb10 names"><i class="el-icon-document mr10"></i>{{item.name}}</div>
                        <div class="mb10 ml10r pointer"><i class="el-icon-download blueColor2"></i></div>
                    </div>
                </div>
            </div>
            
        </div>
        
        
    </div>
</template>

<script>
import titleBar from "@/components/titleBar";
import UeditorBox from "@/components/Ueditor";
import {auctionProjectDetailsById,employAuctionUserDtails} from "@/api/auction/index.js"
import {imageEcho,fileDownLoad} from "@/api/index";
import {ride,except} from "@/util/accuracy"
    export default {
        components: {
            titleBar,
            UeditorBox
        },
        data() {
            return {
                auctionAccount: sessionStorage.getItem("auctionAccount"),
                headers: { sessionId: sessionStorage.getItem("token") },
                form: {},
                biddingInvitedCompanyList: [{name:'',num:'',unit:''}],
                isDisabled: false,
                imagesBox: [], //图片集合
                tableData: [],
                tableData2:[],
                auctionProjectId: "",
                formLabelAlign: {},
                imagesBox2: [],
                aptitudeUrl: []
            }
        },
        filters:{
            examineStatusFilter(val) {
                if(val==1) {
                    return '待审核'
                } else if(val>=2 && val<=6) {
                    return '审核通过'
                } else if(val==7) {
                    return '审核驳回'
                }
            },
            // 待审核,2:待发布,3:即将开始,4:进行中,5:已结束,6:流拍,7:审核驳回
            progressStatusFilters(val) {
                if(val==1) {
                    return '待审核'
                } else if(val==2) {
                    return '待发布'
                } else if(val==3) {
                    return '即将开始'
                } else if(val==4) {
                    return '进行中'
                } else if(val==5) {
                    return '已结束'
                } else if(val==6) {
                    return '流拍'
                } else if(val==7) {
                    return '审核驳回'
                } else {
                    return '--'
                }
            }
        },
        mounted() {
            this.auctionProjectId = this.$route.query.auctionProjectId || ""
            this.getAllDetails(this.auctionProjectId)
            this.getBidRecord()
        },
        methods: {
            //详情回显
            getAllDetails(id) {
                auctionProjectDetailsById({auctionProjectId:id }).then(res=>{
                    if(res.data.code==1) {
                        let data = res.data.data || {}
                        this.form = data || {}
                        this.tableData = data.auctionMark || []
                        let auctionContent = data.auctionContent || {}
                        this.$nextTick(() => {
                            // this.$refs.markIntroduce.setText(auctionContent.markIntroduce);
                            // this.$refs.auctionAnnouncement.setText(auctionContent.auctionAnnouncement);
                        });
                        this.form.biddingNotice = auctionContent.biddingNotice
                        this.form.bondNotice = auctionContent.bondNotice

                        this.form.value2 = [this.form.auctionStartTime,this.form.auctionEndTime]
                        this.form.bond = except(this.form.bond,100)
                        this.form.priceIncrease = except(this.form.priceIncrease,100)
                        this.form.startingPrice = except(this.form.startingPrice,100)

                        // 牌品图片回显
                        let picList = auctionContent.auctionPictureUrl.split(",")
                        picList.forEach(item=>{
                            let imgItem = {};
                            if(item) {
                                imageEcho({ imgPath: item }).then((res) => {
                                    if (res.data.code === 1) {
                                        let filePath = res.data.data.imageCode;
                                        imgItem.filePathUrl = filePath;
                                        this.imagesBox.push(imgItem);
                                    }
                                });
                            }
                        })
                        console.log(this.imagesBox,"this.imagesBox")
                    }
                })
            },
            getBidRecord() {
                employAuctionUserDtails({}).then(res=>{
                    if(res.data.code == 1){
                        this.formLabelAlign = res.data.data || {};
                        if(this.formLabelAlign.aptitudeUrl) {
                            this.aptitudeUrl = JSON.parse(this.formLabelAlign.aptitudeUrl);
                        }
                        //图片回显
                        let picList = this.formLabelAlign.imageUrl.split(",")
                        picList.forEach(item=>{
                            let imgItem = {};
                            if(item) {
                                imageEcho({ imgPath: item }).then((res) => {
                                    if (res.data.code === 1) {
                                        let filePath = res.data.data.imageCode;
                                        imgItem.filePathUrl = filePath;
                                        this.imagesBox2.push(imgItem);
                                    }
                                });
                            }
                        })
                    }
                })
            },
            // 资质信息下载
            uploadClick(item) {
                let fileName = item.name;
                fileDownLoad({ filePath: item.url }).then((res) => {
                    if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(res, fileName);
                    } else {
                    let aTag = document.createElement("a");
                    aTag.download = fileName;
                    aTag.href = URL.createObjectURL(res);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                    }
                });
            }
           
        }
    }
</script>

<style lang="less" scoped>
.projectBox {
    flex: 1;
    width: 1200px;
    margin: 0 auto;
    .flex-form {
        display: flex;
    }
    .header{
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .user {
        margin-right: 15px;
        color: #a8abb2;
        font-size: 16px;
        font-weight: bold;
    }
}
.btnBox {
    text-align: center;
    margin-top: 30px;
}
.project-box {
    text-align: center;
    margin: 20px 0;
    font-weight: 600;
}
.addPic {
    position: absolute;
    top: 4px;
    right: -15px;
    cursor: pointer;
}

.addPicJian {
    position: absolute;
    top: 4px;
    right: -40px;
    cursor: pointer;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}


.details-box {
    display: flex;
    
}
.subject-matter {
    color: #606266;
    font-size: 14px;
    margin-left: 30px;
}
.yellows {
    // /deep/.el-descriptions-item__content{
        color:#FFB129
    // }
}
.img-box {
    width: 200px;
    height: 120px;
    margin-right: 20px;
    border: 1px solid rgb(236, 233, 233);
}
.img-show {
    display: flex;
    flex-wrap: wrap;
    margin-left: 20px;
    position: relative;
}
.flex-form {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.names {
    width:350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}
</style>


// WEBPACK FOOTER //
// src/views/auction/projectDetails.vue